<template>
  <div>
    <ChannelRow
      :channel-id="source.channelId"
      :name="source.name"
      :image="source.avatar"
      :notification-count="(channelById(source.channelId) || {}).notificationCount"
      :active="source.active"
      :sponsor="source.sponsor"
      :enabled="visualSettings.userDirectMessaging"
      :show-status="true"
      :you="activeUser && activeUser.uuid === source.uuid"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import ChannelRow from '@/components/ChannelRow';

export default {
  name: 'ChannelRowVirtualItem',
  components: {
    ChannelRow
  },
  props: [
    'index',
    'source'
  ],
  computed: {
    ...mapGetters([
      'channelById',
      'visualSettings'
    ]),
    ...mapState([
      'activeChannel',
      'activeUser'
    ])
  }
}
</script>

<style scoped lang="scss">
</style>
